import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Dashboard from "./containers/Dashboard";
import Devices from "./containers/Devices";
import Brands from "./containers/Brands";
import Establishments from "./containers/Establishments";
import Residences from "./containers/Residences";
import Screens from "./containers/Screens";
import Settings from "./containers/Settings";
import NotFound from "./containers/NotFound";
import BrandUpdate from "./containers/BrandUpdate";
import EstablishmentUpdate from "./containers/EstablishmentUpdate";
import ResidenceUpdate from "./containers/ResidenceUpdate";
import DeviceUpdate from "./containers/DeviceUpdate";
import ResidenceUsage from "./containers/ResidenceUsage";
import Import from "./containers/Import";
import Export from "./containers/Export";
import Packs from "./containers/Packs";
import PackUpdate from "./containers/PackUpdate";
import APIKeys from "./containers/APIKeys";
import APIKeyCreate from "./containers/APIKeyCreate";
import APIKeyDetails from "./containers/APIKeyDetails";
import DeviceBrands from "./containers/DeviceBrands";
import Users from "./containers/Users";
import PairScreen from "./containers/PairScreen";

function AdminRoute({ children }) {
  const userDB = useSelector((state) => state.userDB);
  if (!userDB || !userDB.admin) return <Navigate to="/" replace />;
  return children;
}

export default function AppRoutes(props) {
  return (
    <Routes>
      <Route path="/" exact element={<Dashboard />} />
      <Route path="/devices" element={<Devices />} />
      <Route path="/add/device" element={<DeviceUpdate />} />
      <Route path="/devices/:id" element={<DeviceUpdate />} />
      <Route path="/brands" element={<Brands />} />
      <Route path="/add/brand" element={<BrandUpdate />} />
      <Route path="/brands/:id" element={<BrandUpdate />} />
      <Route path="/establishments" element={<Establishments />} />
      <Route path="/add/establishment" element={<EstablishmentUpdate />} />
      <Route path="/establishments/:id" element={<EstablishmentUpdate />} />
      <Route path="/residences" element={<Residences />} />
      <Route path="/add/residence" element={<ResidenceUpdate />} />
      <Route path="/residences/:id" element={<ResidenceUpdate />} />
      <Route path="/screens" element={<Screens />} />
      <Route path="/pair-screen" element={<PairScreen />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/view/:id" element={<ResidenceUsage />} />
      <Route path="/import" element={<Import />} />
      <Route path="/import/screens" element={<Import type="screens" />} />
      <Route path="/import/meters" element={<Import type="meters" />} />
      <Route path="/import/packs" element={<Import type="packs" />} />
      <Route path="/import/residences" element={<Import type="residences" />} />
      <Route path="/import/update-keys" element={<Import type="update-keys" />} />
      <Route path="/packs" element={<Packs />} />
      <Route path="/packs/:id" element={<PackUpdate />} />
      <Route path="/api-keys" element={<APIKeys />} />
      <Route path="/add/api-key" element={<APIKeyCreate />} />
      <Route path="/api-keys/:id" element={<APIKeyDetails />} />
      <Route path="/add/pack" element={<PackUpdate />} />
      <Route path="/export" element={<Export />} />
      <Route path="/admin/device-brands" element={<AdminRoute><DeviceBrands /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><Users /></AdminRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
